import { osName } from "react-device-detect";
import PhoneEnabledOutlinedIcon from "@material-ui/icons/PhoneEnabledOutlined";
import googleMapLogo from "../../assets/images/icon/google-maps-logo.svg";
import { Div, Address, Container, Phone, MapRoute, MapBtn } from "./style";
import { connect } from "react-redux";

const Contact = ({ theme }) => {
  return (
    <>
      <Container className="mx-2 my-3 text-right">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d672.5669258278042!2d54.37098248962487!3d31.837933732191242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fa61fff2bcd357b%3A0x9bffd1591d81d52b!2z2KLYsdin24zYtNqv2KfZhyDYrNin2YbYp9mG!5e0!3m2!1sen!2s!4v1636436343514!5m2!1sen!2s"
          width="100%"
          height="350"
          allowfullscreen=""
          title="robanzo"
          loading="lazy"
        ></iframe>
        <Address className="text-center mt-3" theme={theme}>
          آدرس: صفائیه، خیابان ملاصدرا، نبش کوچه 23، طبقه اول
        </Address>
        <Div className="text-center">
          <PhoneEnabledOutlinedIcon />
          <Phone href="tel:03591001770" className="d-inline-block mt-3 f-16">
            03591001770
          </Phone>
        </Div>
        <MapRoute className="mt-3 text-center" theme={theme}>
          مسیر یابی تا رستوران
        </MapRoute>
        <MapBtn
          className="d-block w-50 mx-auto text-center p-2 mt-3"
          theme={theme}
          href={
            osName === "Android"
              ? `geo:0,0?q=31.845502292682685,54.37252657261703(رستوران ایتالیایی رُبانزو)`
              : `maps:0,0?q=(رستوران ایتالیایی رُبانزو)&ll=31.845502292682685,54.37252657261703`
          }
        >
          <img className="img-fluid" src={googleMapLogo} alt="مسیریابی" />
        </MapBtn>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state?.theme,
  };
};

export default connect(mapStateToProps, false)(Contact);
